import React from "react";
import {useEffect, useLayoutEffect, useRef} from "react";
import Suggestion from "./Suggestion";
import "./Suggestions.css";

export default function Suggestions({suggestions, selectSuggestion, suggestionIndex}) {
    const suggestionList = (suggestions != null && suggestions.result != null) ? suggestions.result : [];
    const classes = suggestionList.length > 0 ? 'autocomplete--suggestions' : 'autocomplate--suggestions autocomplete--hidden';
    const suggestionsRef = useRef(null);

    return <div className={classes} ref={suggestionsRef} role="list" id="autocompleteList">
        {suggestionList.map((suggestion, key) => {
              let highlighted = false;
              if (key == suggestionIndex.toString()) {
                highlighted = true;
              }
              return (
                <Suggestion
                highlighted={highlighted}
                key={key}
                suggestion={suggestion}
                selectSuggestion={(address) => selectSuggestion(address, suggestion)}
                />
              );
            }
          )}
    </div>;
}
